<template>
    <!-- Footer -->
    <footer class="footer footer-four">
        <!-- Footer Top -->
        <div class="footer-top footer-top-four aos" data-aos="fade-up">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget">
                            <div class="footer-logo">
                                <router-link to="/home/"><img src="@/assets/img/logo.svg" alt="logo"></router-link>
                            </div>
                            <div class="footer-content footer-content-three">
                                <p>
                                    Online platform where you can discover and book services from a variety of
                                    salons and beauty professionals. From haircuts and styling to massages and
                                    manicures, we offer a convenient way to find the perfect service for your needs.
                                </p>
                            </div>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-xl-2 col-lg-3 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-menu footer-menu-three">
                            <h2 class="footer-title footer-title-three">Discover</h2>
                            <ul>
                                <li>
                                    <a href="javascript:void(0)">Chicago</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Los Angeles</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Miami</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">New York</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Los Vegas</a>
                                </li>
                            </ul>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-xl-2 col-lg-3 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-menu footer-menu-three">
                            <h2 class="footer-title footer-title-three">Lists by Category</h2>
                            <ul>
                                <li>
                                    <a href="javascript:void(0)">Hair style </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Trimming</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Hair makeup</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Beard Trimming</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Box Haircuts</a>
                                </li>
                            </ul>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-xl-2 col-lg-3 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-menu footer-menu-three">
                            <h2 class="footer-title footer-title-three">Quick Links</h2>
                            <ul>
                                <li>
                                    <router-link to="/pages/about-us">About Us </router-link>
                                </li>
                                <li>
                                    <router-link to="/pages/terms-condition">Terms & Conditions</router-link>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Support Center</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Contact Us</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">User’s Guide</a>
                                </li>
                            </ul>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-menu footer-menu-three">
                            <h2 class="footer-title footer-subtitle-three">
                                Contact Info
                            </h2>

                        </div>
                        <div class="footer-widget footer-menu footer-menu-three">
                            <h2 class="footer-title footer-subtitle-three fs-14">
                                Need live support?
                            </h2>
                            <p class="fs-16">truelysell@example.com</p>
                        </div>
                        <div class="footer-widget footer-menu footer-menu-three">
                            <h2 class="footer-title footer-subtitle-three fs-14">
                                Toll Free Customer Care
                            </h2>
                            <p class="fs-16">+91 26447 99875</p>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                </div>
            </div>
        </div>
        <!-- /Footer Top -->

        <!-- Footer Bottom -->
        <div class="footer-bottoms">
            <div class="container">
                <!-- Copyright -->
                <div class="copyright">
                    <div class="row align-items-center gy-3">
                        <div class="col-lg-4 col-md-6 d-flex">
                            <div class="copyright-text copyright-color">
                                <p class="mb-0 fs-16">
                                    &copy; 2024 Truelysell. All Rights Reserved.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6  d-flex justify-content-lg-center">
                            <!-- Copyright Menu -->
                            <div class="copyright-menu">
                                <ul class="policy-menu">
                                    <li>
                                        <a href="javascript:void(0)">Side Map</a>
                                    </li>
                                    <li>
                                        <router-link to="/pages/privacy-policy">Privacy policy</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/pages/privacy-policy">Cookie Policy</router-link>
                                    </li>
                                </ul>
                            </div>
                            <!-- /Copyright Menu -->
                        </div>
                        <div class="col-lg-4 col-md-6  d-flex justify-content-lg-center">
                            <!-- Copyright Menu -->
                            <div class="copyright-menu">
                                <ul class="policy-menu">
                                    <li>
                                        <a href="javascript:void(0)"><i class="ti ti-brand-facebook-filled"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="ti ti-brand-twitter-filled"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="ti ti-brand-instagram"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="ti ti-brand-google-filled"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="ti ti-brand-youtube-filled"></i></a>
                                    </li>
                                </ul>
                            </div>
                            <!-- /Copyright Menu -->
                        </div>
                    </div>
                </div>
                <!-- /Copyright -->
            </div>
        </div>
        <!-- /Footer Bottom -->
    </footer>
    <!-- /Footer -->
</template>